module.exports = __webpack_public_path__ + "img/piston-push.fff4e43b.png";